import React, { Component } from "react";
import PropTypes from "prop-types";
import CSSTransition from "react-transition-group/CSSTransition";
import { SMALL_VIEWPORT, viewportPropType } from "../../state/modules/layout";
import IconButton from "../IconButton";
import IconNotification from "../IconNotification";
import Widget from "./Widget";
import styles from "./Widgets.css";
import Dropdown from "../Dropdown";
import Greeter from "../Greeter";
import MyAccountLinks from "../MyAccountLinks";
import MiniBag from "../MiniBag";
import MiniBagHeader from "../MiniBag/Header";
import MiniBagFooter from "../MiniBag/Footer";
import withTranslation from "../translation";
import widgetStyles from "./Widget/index.css";
import { getMyAccountBaseUrl } from "../../helpers/externalLinks";
import { withParams } from "../../../helpers/queryString";
import { MY_ACCOUNT, MINIBAG } from "../../state/modules/dropdown";
import isBagPage from "../../helpers/isBagPage";
const trackingQuery = "?nlid=nav header";

const ENTER_KEY = 13;
const keyCode = e => e.keyCode || e.which;

class Widgets extends Component {
  state = {
    isBagIconAnimating: false,
    isBagPage: false
  };

  componentDidMount = () => {
    const { getSavedItemsFromSDK } = this.props;
    getSavedItemsFromSDK();
    this.setState({
      isBagPage: isBagPage(window.location.pathname)
    });
  };

  componentWillReceiveProps = nextProps => {
    const { noOfBagItems } = this.props;

    if (nextProps.isUpdated && nextProps.noOfBagItems > noOfBagItems) {
      this.toggleAnimation();
    }
  };

  handleSearch = () => {
    const { openSearch } = this.props;
    openSearch();
  };

  toggleAnimation = () => {
    this.setState(state => ({
      isBagIconAnimating: !state.isBagIconAnimating
    }));
  };

  searchWidget = () => {
    const { formatTranslation } = this.props;

    return (
      <Widget viewable={[SMALL_VIEWPORT]}>
        <IconButton
          type="button"
          icon="search"
          onClick={this.handleSearch}
          data-testid="searchIcon"
          className={styles.widgetButton}
          aria-label={formatTranslation("Icon.Search")}
        />
      </Widget>
    );
  };

  accountWidget = () => {
    const {
      countryCode,
      eventIconToggle,
      formatTranslation,
      isLoggedIn,
      isReconsentRequired,
      keyStoreDataversion,
      lang,
      myAccountOpen,
      storeCode,
      viewport
    } = this.props;

    const { christmas } = eventIconToggle;

    let iconName = isLoggedIn ? `accountFilled` : `accountUnfilled`;

    if (christmas) {
      iconName = isLoggedIn
        ? `accountChristmasFilled`
        : `accountChristmasUnfilled`;
    }

    if (viewport !== SMALL_VIEWPORT) {
      return (
        <Widget className={widgetStyles.myAccountWidget}>
          <Dropdown
            name={MY_ACCOUNT}
            header={<Greeter />}
            body={<MyAccountLinks />}
            footer={null}
          >
            <IconButton
              type="button"
              icon={iconName}
              data-testid="accountIcon"
              className={styles.widgetButton}
              aria-expanded={myAccountOpen}
              aria-controls="myaccount-dropdown"
              aria-label={formatTranslation("Icon.MyAccount")}
            />
            {isReconsentRequired ? (
              <IconNotification data-testid="gdpr-icon-notification" />
            ) : null}
          </Dropdown>
        </Widget>
      );
    } else {
      const params = {
        lang,
        store: storeCode,
        country: countryCode,
        keyStoreDataversion,
        nlid: "nav header"
      };

      const href = withParams(getMyAccountBaseUrl(), params);

      return (
        <Widget className={widgetStyles.myAccountWidget}>
          <IconButton
            type="a"
            href={href}
            icon={iconName}
            data-testid="accountIcon"
            className={styles.widgetButton}
            aria-label={formatTranslation("Icon.MyAccount")}
          >
            {isReconsentRequired ? (
              <IconNotification data-testid="gdpr-icon-notification" />
            ) : null}
          </IconButton>
        </Widget>
      );
    }
  };

  bagWidget = () => {
    const {
      viewport,
      noOfBagItems,
      defaultStoreUrl,
      miniBagToggle,
      formatTranslation
    } = this.props;
    const { isBagPage } = this.state;
    const bagIconName = noOfBagItems ? "bagFilled" : "bagUnfilled";

    const bagUrl = defaultStoreUrl.concat(
      formatTranslation("Bag.Link"),
      trackingQuery
    );

    const bagAriaLabel = `${formatTranslation(
      "Icon.Bag"
    )} ${formatTranslation("MiniBag.ItemCount", {
      smart_count: noOfBagItems
    })}`;

    const bagIcon = (hasDropdown = false) => (
      <IconButton
        type="a"
        href={bagUrl}
        onClick={e => hasDropdown && e.preventDefault()}
        onKeyDown={e => {
          if (keyCode(e) === ENTER_KEY) {
            window.location.assign(bagUrl);
            e.preventDefault();
          }
        }}
        icon={bagIconName}
        data-testid="bagIcon"
        className={styles.widgetButton}
        aria-label={bagAriaLabel}
      >
        {noOfBagItems && (
          <span className={styles.noOfBagItems}>{noOfBagItems}</span>
        )}
      </IconButton>
    );

    return (
      <Widget>
        {!isBagPage &&
        viewport !== SMALL_VIEWPORT &&
        miniBagToggle &&
        noOfBagItems ? (
          <Dropdown
            name={MINIBAG}
            header={<MiniBagHeader />}
            body={<MiniBag />}
            footer={<MiniBagFooter />}
            isKeyboardAccessible={false}
          >
            {bagIcon(true)}
          </Dropdown>
        ) : (
          <CSSTransition
            in={this.state.isBagIconAnimating}
            timeout={1000}
            classNames="bounce"
            onEntered={this.toggleAnimation}
          >
            {bagIcon()}
          </CSSTransition>
        )}
      </Widget>
    );
  };

  savedItemsWidget = () => {
    const { hasSavedItems, formatTranslation, defaultStoreUrl } = this.props;

    return (
      <Widget>
        <IconButton
          type="a"
          href={defaultStoreUrl.concat(
            formatTranslation("SavedItems.Link"),
            trackingQuery
          )}
          icon={hasSavedItems ? `heartFilled` : `heartUnfilled`}
          data-testid="savedItemsIcon"
          className={styles.widgetButton}
          aria-label={formatTranslation("Icon.SavedItems")}
        />
      </Widget>
    );
  };

  render() {
    return (
      <ul className={styles.container} data-testid="widgets">
        {this.searchWidget()}
        {this.accountWidget()}
        {this.savedItemsWidget()}
        {this.bagWidget()}
      </ul>
    );
  }
}

Widgets.propTypes = {
  countryCode: PropTypes.string.isRequired,
  defaultStoreUrl: PropTypes.string.isRequired,
  eventIconToggle: PropTypes.oneOfType([
    PropTypes.shape({
      christmas: PropTypes.bool
    }),
    PropTypes.bool
  ]),
  formatTranslation: PropTypes.func.isRequired,
  getSavedItemsFromSDK: PropTypes.func.isRequired,
  hasSavedItems: PropTypes.bool.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  isReconsentRequired: PropTypes.bool.isRequired,
  isUpdated: PropTypes.bool,
  keyStoreDataversion: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired,
  miniBagToggle: PropTypes.bool,
  myAccountOpen: PropTypes.bool,
  noOfBagItems: PropTypes.number,
  openSearch: PropTypes.func.isRequired,
  storeCode: PropTypes.string.isRequired,
  viewport: viewportPropType
};

export default withTranslation(Widgets);



// WEBPACK FOOTER //
// ./template/components/Widgets/Widgets.js